const sharePost = () => {
    const copyButton = document.getElementById('share-button--copy');
    const feedback = document.getElementById('share-buttons__copied');

    if (!copyButton || !feedback) return;

    copyButton.addEventListener('click', async () => {
        const linkToCopy = copyButton.getAttribute('data-url');

        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(linkToCopy);
            } else {
                const input = document.createElement('textarea');
                input.value = linkToCopy;
                input.style.position = 'fixed';
                input.style.opacity = '0';
                document.body.appendChild(input);
                input.select();
                document.body.removeChild(input);
            }

            feedback.classList.add('show');

            setTimeout(() => {
                feedback.classList.remove('show');
            }, 2000);

        } catch (err) {
            console.error('Error:', err);
            feedback.textContent = 'Error!';
            feedback.style.background = '#AC1524';
            feedback.classList.add('show');
        }
    });
}

export { sharePost };